export enum FavoredTypeEnum {
  Account = '1',
  Pix = '2',
}
